const style = {
  modal: {
    width: "90vw",
    maxWidth: "1000px",
    height: "90vh",
    background: "#1e212b",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
    border: "1px solid #2a2f3b",
    color: "#FFF",
    overflow: "hidden",
  },
  modalHeader: {
    padding: "20px 25px",
    borderBottom: "1px solid #2a2f3b",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexShrink: 0,
  },
  title: {
    fontSize: "20px",
    fontWeight: "600",
    margin: 0,
  },
  closeBtn: {
    background: "none",
    border: "none",
    color: "#aeb9c4",
    cursor: "pointer",
    padding: "5px",
  },
  modalBody: {
    flexGrow: 1,
    padding: "25px",
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    minHeight: 0,
  },
  filters: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr",
    gap: '15px',
    flexShrink: 0,
  },
  filterBox: {
    display: "flex",
    flexDirection: "column",
  },
  filterName: {
    fontSize: "14px",
    fontWeight: '500',
    color: "#aeb9c4",
    marginBottom: '8px'
  },
  inputWrapper: { position: "relative" },
  inputIcon: {
    position: "absolute",
    left: "15px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#aeb9c4",
  },
  input: {
    width: "100%",
    height: "45px",
    background: "#2a2f3b",
    border: "1px solid #3c4257",
    borderRadius: "12px",
    padding: "0 20px 0 45px",
    boxSizing: "border-box",
    color: "#FFF",
    fontSize: "14px",
    outline: "none",
  },
  tagButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: "45px",
    background: "#2a2f3b",
    border: "1px solid #3c4257",
    borderRadius: "12px",
    color: "#aeb9c4",
    fontSize: "14px",
    cursor: "pointer",
  },
  searchButton: {
    height: "45px",
    background: '#4ecf78',
    color: '#1e212b',
    border: 'none',
    borderRadius: '12px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  tableContainer: {
    flexGrow: 1,
    border: "1px solid #2a2f3b",
    borderRadius: "12px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  tableHeaderRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 20px",
    background: '#2a2f3b',
    borderBottom: '1px solid #3c4257',
  },
  tableTitleWrapper: {
    display: 'flex',
    alignItems: 'center',
    color: '#FFF',
    fontWeight: '600',
  },
  tableTitle: {
    fontSize: 16,
  },
  selectAllAndPagination: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  selectAllBox: {
    display: "flex",
    alignItems: 'center',
    gap: 8,
  },
  selectAllBoxTitle: {
    fontSize: 14,
    color: "#aeb9c4",
    cursor: 'pointer'
  },
  tableHeader: {
    display: "grid",
    gridTemplateColumns: "50px 2fr 1.5fr 1.5fr",
    padding: "12px 20px",
    background: '#2a2f3b',
    borderBottom: '1px solid #3c4257',
    alignItems: 'center',
  },
  checkbox: {
    width: '18px',
    height: '18px',
    cursor: 'pointer'
  },
  tableHeaderCell: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#aeb9c4',
  },
  tableBody: {
    flexGrow: 1,
    overflowY: 'auto'
  },
  tableRow: {
    display: "grid",
    gridTemplateColumns: "50px 2fr 1.5fr 1.5fr",
    padding: "10px 20px",
    borderBottom: "1px solid #2a2f3b",
    alignItems: "center",
  },
  tableCell: { fontSize: "14px" },
  clientName: { fontWeight: "600" },
  contactCell: { color: "#aeb9c4" },
  dateCell: { color: "#aeb9c4", fontSize: "13px" },
  emptyState: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    color: '#aeb9c4',
  },
  selectedCounter: {
    padding: "8px 16px",
    background: "rgba(78, 207, 120, 0.1)",
    color: "#4ecf78",
    borderRadius: "6px",
    margin: "0 25px 15px 25px",
    fontSize: "14px",
    fontWeight: "600",
    alignSelf: "flex-start",
  },
  modalFooter: {
    padding: '20px 25px',
    borderTop: '1px solid #2a2f3b',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexShrink: 0,
  },
  selectionInfo: {
    color: '#aeb9c4',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
  },
  agentAndSend: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  selectNumberPart: {
    display: "flex",
    alignItems: "center",
    gap: 10
  },
  selectNumberPartText: {
    fontSize: "14px",
    color: "#aeb9c4",
  },
  selectNumberPartButton: {
    background: "none",
    border: '1px solid #3c4257',
    color: '#aeb9c4',
    padding: '8px 15px',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  selectedAgentBox: {
    display: "flex",
    gap: 10,
    alignItems: "center",
    background: '#2a2f3b',
    padding: '5px 10px',
    borderRadius: '8px',
  },
  selectedAgentBoxMessage: {
    fontSize: 14,
    fontWeight: "600",
  },
  selectedAgentBoxUnselectButton: {
    background: 'none',
    border: 'none',
    color: '#ff5b5b',
    cursor: 'pointer',
    display: 'flex',
  },
  sendMessagesButton: {
    display: 'flex',
    alignItems: 'center',
    background: '#4ecf78',
    color: '#1e212b',
    border: 'none',
    borderRadius: '10px',
    padding: '10px 20px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  paginationContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  paginationButton: {
    background: "none",
    border: "1px solid #3c4257",
    color: "#aeb9c4",
    height: '32px',
    minWidth: '32px',
    padding: "0 8px",
    borderRadius: "8px",
    cursor: "pointer",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: '600'
  },
  activeButton: {
    background: '#4ecf78',
    borderColor: '#4ecf78',
    color: '#1e212b',
  },
  disabledButton: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  ellipsis: {
    color: '#aeb9c4',
    padding: '0 5px'
  },
};

export default style;